import { useTranslation } from 'react-i18next'
import type { ForwardHeaders } from '@/lib/inbox/email-quotes-text'

/**
 * The Från/Datum/Till/Ämne card at the top of a forwarded message (board eeqo).
 * The HTML view renders the same markup inside its frame (`email-quotes-html.ts`).
 */
export function ForwardedHeader({ headers }: { headers: ForwardHeaders }) {
  const { t } = useTranslation('inbox')
  const rows: Array<[string, string | undefined]> = [
    [t('body.fwdFrom'), headers.from],
    [t('body.fwdDate'), headers.date],
    [t('body.fwdTo'), headers.to],
    [t('body.fwdSubject'), headers.subject],
  ]
  const present = rows.filter((row): row is [string, string] => Boolean(row[1]))
  if (present.length === 0) return null
  return (
    <dl
      data-slot="forwarded-header"
      className="mb-3 grid grid-cols-[auto_1fr] gap-x-3 gap-y-0.5 border-b pb-2 text-sm"
    >
      {present.map(([label, value]) => (
        <div key={label} className="contents">
          <dt className="text-muted-foreground">{label}</dt>
          <dd className="min-w-0 break-words">{value}</dd>
        </div>
      ))}
    </dl>
  )
}
